export default __webpack_public_path__ + "static/media/GW.6a251ec8.svg";